import { Component, OnInit, Optional } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-add-staff-dialog',
  templateUrl: './add-staff-dialog.component.html',
  styleUrls: ['./add-staff-dialog.component.scss']
})
export class AddStaffDialogComponent implements OnInit {
  navigation: 'back' | 'next' = 'back';
  isUploadPanel = false;
  constructor(@Optional() public dialogRef: MatDialogRef<AddStaffDialogComponent>) { }

  ngOnInit(): void {
  }

  goBack() {
    this.navigation = 'back';
    this.isUploadPanel = false;
  }

}
